
import { defineComponent, PropType } from "vue";
import { IMember } from "@/types/Members";
import ModalView from "@/components/Modal.vue";
import { WpApiMembers } from "@/types/WpApi";

declare let wpApiMembers: WpApiMembers;

export default defineComponent({
  name: "Team-Member",
  props: {
    member: {
      type: Object as PropType<IMember>,
      default: null,
    },
  },
  data() {
    const {
      post_title,
      acf: {
        fields_of_activity: { value: fieldsOfActivity },
        contact: {
          value: { phone, email },
        },
        image: { value: memberImage },
        job_fields: { value: jobFields },
      },
    } = this.member;
    return {
      isOpen: false,
      name: post_title,
      image: memberImage,
      jobFields: jobFields,
      phone: phone,
      email: email,
      fieldsOfActivity: fieldsOfActivity,
      hideNames: Boolean(wpApiMembers.hideNames),
      isRound: Boolean(wpApiMembers.isRound),
      hideJobFields: Boolean(wpApiMembers.hideJobFields),
      showOnlyFirstJobField: Boolean(wpApiMembers.showOnlyFirstJobField),
    };
  },
  computed: {
    showModal() {
      const showName = this.member.acf.show_name.value;
      const hasFieldsOfActivity =
        this.fieldsOfActivity && this.fieldsOfActivity.length > 0;
      const hasJobFields = this.jobFields && this.jobFields.length > 0;

      console.log({
        "Boolean(wpApiMembers.hideJobFields)": Boolean(
          wpApiMembers.hideJobFields
        ),
        "!this.hideNames": !this.hideNames,
        showName: showName,
        "this.name": Boolean(this.name),
        "!this.hideJobFields": !this.hideJobFields,
        hasJobFields: hasJobFields,
        hasFieldsOfActivity: hasFieldsOfActivity,
        "this.email": Boolean(this.email),
        phone: Boolean(this.phone),
        result:
          (!this.hideNames || (showName && Boolean(this.name))) &&
          (!this.hideJobFields || hasJobFields) &&
          hasFieldsOfActivity &&
          Boolean(this.email) &&
          Boolean(this.phone),
      });

      return (
        (!this.hideNames || (showName && Boolean(this.name))) &&
        (!this.hideJobFields || hasJobFields) &&
        hasFieldsOfActivity &&
        Boolean(this.email) &&
        Boolean(this.phone)
      );
    },
  },
  methods: {
    handleModalOpen(event: MouseEvent | TouchEvent) {
      if (!this.showModal) {
        return;
      }
      if (event) {
        event.stopPropagation();
      }
      this.isOpen = !this.isOpen;
    },
  },
  components: {
    ModalView,
  },
});
